module.exports = __webpack_public_path__ + "img/onova.217a9a04.gif";